import { Route, Routes } from 'react-router-dom'
import { TableAnalysisSalesInvoices } from './table/table'


export const BrowserAnalysisSalesInvoices = () => {
    return (
        <Routes>
            <Route path={"/"} element={<TableAnalysisSalesInvoices />} />
        </Routes>
    )
}